import { render, staticRenderFns } from "./Contests.vue?vue&type=template&id=d96fdb06&scoped=true"
import script from "./Contests.vue?vue&type=script&lang=ts"
export * from "./Contests.vue?vue&type=script&lang=ts"
import style0 from "./Contests.vue?vue&type=style&index=0&id=d96fdb06&prod&lang=css"
import style1 from "./Contests.vue?vue&type=style&index=1&id=d96fdb06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d96fdb06",
  null
  
)

export default component.exports